import React from 'react';
import PropTypes from 'prop-types';
import { BellIcon } from '@heroicons/react/24/outline';
import { BellIcon as BellSolidIcon } from '@heroicons/react/24/solid';

const NotificationTrigger = ({ openCount, onOpen, color = 'primary', inMenu = false }) => {
  const handleClick = () => {
    onOpen();
  };

  return (
    <button
      className="relative flex items-center justify-center w-10 h-10 transition-colors duration-200 focus:outline-none focus:ring-2 rounded-lg"
      style={{
        color: 'var(--succession-text-secondary)',
        focusRing: 'var(--succession-focus-ring)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = 'var(--succession-primary)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = 'var(--succession-text-secondary)';
      }}
      onClick={handleClick}
      title={`Notifications (${openCount} unread)`}
      aria-label={`Notifications (${openCount} unread)`}
    >
      {/* Bell Icon */}
      {openCount > 0 ? (
        <BellSolidIcon 
          className="w-6 h-6" 
          style={{ color: 'var(--succession-primary)' }}
        />
      ) : (
        <BellIcon className="w-6 h-6" />
      )}

      {/* Notification Badge */}
      {openCount > 0 && (
        <div 
          className="absolute -top-1 -right-1 min-w-5 h-5 text-white text-xs font-bold rounded-full flex items-center justify-center px-1"
          style={{
            backgroundColor: 'var(--succession-error)',
          }}
        >
          {openCount > 99 ? '99+' : openCount}
        </div>
      )}
    </button>
  );
};

NotificationTrigger.propTypes = {
  openCount: PropTypes.number,
  onOpen: PropTypes.func.isRequired,
  color: PropTypes.string,
  inMenu: PropTypes.bool,
};

NotificationTrigger.defaultProps = {
  openCount: 0,
  color: 'primary',
  inMenu: false,
};

export default NotificationTrigger; 